<template>
  <button v-if="buttonStyle == 0" type="button" class="btn btn-primary" @click="showModal()"><font-awesome-icon icon="plus" /> Neue Application</button>

  <button v-else-if="buttonStyle == 1" type="button" class="btn btn-primary w-100" @click="showModal()">
    <font-awesome-icon icon="plus" class="me-2" /> Neue Application hinzufügen
  </button>

  <button v-else type="button" class="btn btn-primary btn-sm" title="Application bearbeiten" @click="showModal()">
    <font-awesome-icon icon="pen" />
  </button>

  <!-- Edit ApplicationModal -->
  <div
    class="modal fade"
    :id="'editApplicationModal' + index"
    tabindex="-1"
    :aria-labelledby="'editApplicationModal' + index"
    aria-hidden="true"
    ref="editApplicationModalRef"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header bg-primary py-2" data-bs-theme="dark">
          <span v-if="editApplication.id == 0" class="modal-title my-auto text-white" :id="'editApplicationModalLabel' + index">Neue Application</span>

          <span v-else class="modal-title my-auto text-white" :id="'editApplicationModalLabel' + index">Application bearbeiten</span>

          <button type="button" class="btn-close btn-sm" @click="closeModal()"></button>
        </div>

        <div class="modal-body" :id="'editApplicationModalBody' + index">
          <LoadingSpinner v-if="loading" />

          <form v-else @submit.prevent="saveApplication">
            <div class="mb-3">
              <label :for="'applicationTitel-' + index" class="form-label fw-bold">Titel</label>
              <input type="text" class="form-control" :id="'applicationTitel-' + index" v-model="editApplication.titel" />
            </div>

            
            <hr class="my-3" />

            <div v-if="errorMsg != ''" class="alert alert-danger mb-3">
              Es ist ein Fehler aufgetreten:<br />
              {{ errorMsg }}
            </div>

            <div class="d-flex justify-content-end">
              <button type="button" class="btn btn-secondary me-3" @click="closeModal()">Abbrechen</button>
              <button type="submit" class="btn btn-primary">Speichern</button>
            </div>
          </form>
        </div>

        <div v-if="!loading && editApplication.id != 0" class="modal-footer justify-content-start">
          <button type="button" class="btn btn-danger" @click="deleteApplication()"><font-awesome-icon icon="trash" /> Application löschen</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
//#region Imports
  import { PropType, computed, ref } from 'vue';
  import { Modal } from 'bootstrap';
  import { useCommonStore } from '@/stores/commonStore';
  import { useAuthStore } from '@/stores/authStore';
  import { useApplicationsStore } from '@/stores/applicationsStore';

  import { Application } from '@/models/ApplicationsModels';

  import LoadingSpinner from '../LoadingSpinner.vue';
  //#endregion

  const props = defineProps({
    application: {
      type: Object as PropType<Application>,
      default: new Application(),
    },

    index: {
      type: Number as PropType<number>,
      required: true,
    },

    buttonStyle: {
      type: Number as PropType<number>,
      default: 0, // 0 = erstellen; 1 = bearbeiten
    },
  });

  const emits = defineEmits(['deleteApplication']);

  const authStore = useAuthStore();
  const applicationsStore = useApplicationsStore();
  const commonStore = useCommonStore();


  const loading = computed(() => commonStore.status.createApplicationLoading || commonStore.status.updateApplicationLoading);
  const errorMsg = computed(() => commonStore.status.applicationErrorMsg);

  const editApplication = ref(JSON.parse(JSON.stringify(props.application)) as Application);

  function saveApplication() {
    editApplication.value.titel = editApplication.value.titel.trim();
    
    if (editApplication.value.id !== 0) {
      applicationsStore.updateApplication(editApplication.value).then(() => {
        if (errorMsg.value == '') {
          closeModal();
        }
      });
    } else {
      editApplication.value.userId = authStore.kc.tokenParsed?.sub || '';

      applicationsStore.createApplication(editApplication.value).then(() => {
        if (errorMsg.value == '') {
          closeModal();
        }
      });
    }
  }

  function deleteApplication() {
    closeModal();
    emits("deleteApplication", props.application);
  }

    //#region Modal
  const editApplicationModalRef = ref();
  
  function closeModal() {
    Modal.getInstance(editApplicationModalRef.value)?.hide();
  }

  function showModal() {
    if (editApplicationModalRef.value) {
      editApplication.value = JSON.parse(JSON.stringify(props.application)) as Application;

      new Modal(editApplicationModalRef.value).show();
    }
  }
  //#endregion
</script>

<style scoped>
  .modal-content {
    background: rgb(242, 243, 248);
  }

  /* .modal-body {
  background: rgb(242, 243, 248);
}

.modal-footer {
  background: rgb(242, 243, 248);
} */
</style>
